import { ApiError } from './api';
import { SESSION_PROTOCOL_VERSION } from './session-core';

export interface ReplayPlayer { userId:string; displayName:string; telegramPhotoUrl:string|null; hasCustomPhoto:boolean }
export interface ReplayRound { roundNumber:number; question:string; answers:Array<{userId:string;displayName:string;label:string;role:'choice'|'actual'|'prediction'}>; result:'same'|'different'|'correct'|'surprise'|'survived'|'matched'; reactions:Array<{userId:string;reaction:string}> }
export interface ReplayManifest { version:1; sessionId:string; momentKey:'deep'|'same_brain'|'read_me'|'dont_match'; interactionType:'same_brain'|'read_me'|'dont_match'; interactionLabel:string; completedAt:string; players:ReplayPlayer[]; rounds:ReplayRound[]; score:{value:number;total:number;percent:number;label:string}; highlightRoundNumber:number; shareCopy:string }
export interface ReplayDownload { url:string; fileName:string; expiresAt:string }

const headers = (initData: string) => ({
  Accept: 'application/json',
  Authorization: `tma ${initData}`,
  'X-UTAGE-Protocol': String(SESSION_PROTOCOL_VERSION)
});

export const loadReplayManifest = async (id: string, initData: string): Promise<ReplayManifest> => {
  const response = await fetch(`/api/v1/replays/${encodeURIComponent(id)}/manifest`, { cache:'no-store', headers:headers(initData) });
  const body = await response.json().catch(() => ({})) as { replay?:ReplayManifest; error?:{code?:string;message?:string} };
  if (!response.ok || !body.replay) throw new ApiError(body.error?.message ?? 'Could not prepare this replay.', body.error?.code);
  return body.replay;
};

export const loadReplayVideo = async (id: string, initData: string): Promise<Blob> => {
  const response = await fetch(`/api/v1/replays/${encodeURIComponent(id)}/video`, {
    cache:'no-store',
    headers:{ Authorization:`tma ${initData}`, 'X-UTAGE-Protocol':String(SESSION_PROTOCOL_VERSION) }
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({})) as { error?:{code?:string;message?:string} };
    throw new ApiError(body.error?.message ?? 'Could not make this replay yet.', body.error?.code);
  }
  return response.blob();
};

export const requestReplayDownload = async (id: string, initData: string): Promise<ReplayDownload> => {
  const response = await fetch(`/api/v1/replays/${encodeURIComponent(id)}/download-ticket`, {
    method:'POST',
    cache:'no-store',
    headers:headers(initData)
  });
  const body = await response.json().catch(() => ({})) as { download?:ReplayDownload; error?:{code?:string;message?:string} };
  if (!response.ok || !body.download) throw new ApiError(body.error?.message ?? 'Could not prepare the download yet.', body.error?.code);
  return body.download;
};
